<template lang="pug">
  app-modal.modalNotificar(
    :titulo="titulo",
    v-if="showModal"
    :width="1000"
    @closeModal="closeModal"
  )
    template(slot="body")
      app-search-despachos(
        @search="search",
        @input="search",
        @clear="clear",
      )
      div(v-if="modelos.length === 0")
        p.center Ainda não há modelos disponíveis
      div.container-modelo
        div.item(v-for='item in modelos', :key="item.id")
          div(@click='selectModelo(item.id)')
            el-card.cursor-pointer(:class="{ active: item.id === selectedModelo.id }")
              span.descricao {{ item.descricaoTexto }}
              p.border-bottom
              p(v-html="item.textoModelo")
    template(slot="footer")
      app-utilizar-buttons(@cancel="closeModal", @confirm="save", :textModel="selectedModelo.textoModelo")
</template>

<script>
import { mapActions } from 'vuex'

import AppUtilizarButtons from './AppUtilizarButtons'
import AppSearchDespachos from './AppSearchDespachos'
import AppModal from '@/components/AppModal'

export default {

  components: {
    AppUtilizarButtons,
    AppSearchDespachos,
    AppModal
  },
  props: {
    tiposModelo: {
      type: Array
    },
    idProcesso: {
      type: Number,
      required: false
    },
    showModal: {
      type: Boolean,
      required: true
    },
    titulo: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      selectedModelo: {},
      filtro: { parametro: '', tiposModelo: this.tiposModelo },
      modelos: []
    }
  },

  async created () {
    const data = await this.findByFiltroSelecao(this.filtro)
    this.modelos = data
  },

  methods: {
    ...mapActions({
      findByFiltroSelecao: 'modeloDespacho/findByFiltroSelecao',
      findByFiltroSelecaoAndProcesso: 'despacho/findByFiltroSelecaoAndProcesso',
      getDespachoWithData: 'despacho/getDespachoWithData',
      getDespachoDinamicoWithData: 'despacho/getDespachoDinamicoWithData',
      getDespachoRegistroImovel: 'despacho/getDespachoRegistroImovel'
    }),

    closeModal () {
      this.$emit('closeModal')
    },

    async save () {
      if (this.selectedModelo.textoModelo) {
        switch (this.selectedModelo.tipoModelo) {
          case 2: // se é notificação
            this.selectedModelo.textoModelo = await this.getDespachoDinamicoWithData({idProcesso: this.idProcesso, idModelo: this.selectedModelo.id})
            this.$emit('setTextoNotificacao', this.selectedModelo.textoModelo)
            break
          case 3: // se é titulo
            this.selectedModelo.textoModelo = await this.findByFiltroSelecaoAndProcesso({idProcesso: this.idProcesso, idModelo: this.selectedModelo.id})
            this.$emit('setTextoTitulo', this.selectedModelo.textoModelo)
            break
          case 4: // se é despacho REURB
            this.selectedModelo.textoModelo = await this.getDespachoWithData({idProcesso: this.idProcesso, idModelo: this.selectedModelo.id})
            this.$emit('setTextoDespacho', this.selectedModelo.textoModelo)
            break
          case 5: // se é registro de imovel
            this.selectedModelo.textoModelo = await this.getDespachoRegistroImovel({idProcesso: this.idProcesso, idModelo: this.selectedModelo.id})
            this.$emit('setTextoTitulo', this.selectedModelo.textoModelo)
            break
          case 7: // se é justificativa
            this.selectedModelo.textoModelo = await this.getDespachoDinamicoWithData({idProcesso: this.idProcesso, idModelo: this.selectedModelo.id})
            this.$emit('setTextoJustificativa', this.selectedModelo.textoModelo)
            break
          default: // se é despacho
            this.$emit('setTextoDespacho', this.selectedModelo.textoModelo)
            break
        }
      }
      this.closeModal()
    },

    async search (param) {
      this.filtro.parametro = param
      let data = await this.findByFiltroSelecao(this.filtro)
      this.modelos = data
    },

    clear () {

    },

    selectModelo (id) {
      if (this.selectedModelo.id === id) {
        this.selectedModelo = {}
      } else {
        this.selectedModelo = this.modelos.find(x => x.id === id)
      }
    }
  }
}

</script>

<style scoped lang="scss">
.center {
  text-align: center;
  margin-top: 20px !important;

}
p.message {
  width: 80%;
  margin: 0 auto;
}

.center {
  margin-top: 40px !important;
  text-align: center;
}

.item {
  margin: 5px;
  width: 310px;
}

.el-card {
  max-width: 100%;
  height: 350px;
  font-size: 12px !important;
}

.cursor-pointer {
  cursor: pointer;
}

.container-modelo {
  padding-top: 22px;
  display: flex;
  flex-wrap: wrap;
}
.descricao {
  font-weight: bold;
  font-size: 16px;
}

.border-bottom {
  padding-bottom: 10px;
  border-bottom: solid 1px #A7B2BA;
}

.active {
  background: rgb(223, 223, 223) !important;
}

@media (max-width: 780px) {
  .modalNotificar {
    position: fixed !important;
    width: 395px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppModalSelecionarModeloNotificacao.vue